import React, { useMemo, useState } from 'react';
import AdministrationModal from '../AdministrationModal/AdministrationModal';
import AdministrationTypeTable from '../AdministrationTypeTable/AdministrationTypeTable';
import { MdDeleteForever, MdModeEdit } from 'react-icons/md';
import {canModifyUser} from '../../../utils/adminHelperFunctions';
import { useTranslation } from 'react-i18next';
const styles = {
  container : { width: '90%', margin: '0 auto', marginBottom: '1rem' },
  card      : { 'boxShadow' : 'rgba(0, 0, 0, 0.2) 0px 0px 10px -2px', marginTop: "1rem", minHeight: '400px' },
  headers   : { 'textAlign' : 'left', 'lineHeight' : '2rem', },
  prewrap   : { 'whiteSpace': 'pre-wrap' },
  delete    : { color: 'red', cursor: 'pointer' },
  edit      : { color: '#ffc107', cursor: 'pointer' }
}

const type = 'users';

export const Users = ({users, userState}) => {
  const { user: { authorization }}    = userState;
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalType, setModalType]     = useState("");
  const [modalAction, setModalAction] = useState("");
  const [selectedData, setSelectedData] = useState({})
  const { t } = useTranslation(["translation"]);
  
  const modalData = useMemo(() => {
    switch (modalType) {
      case "Delete User":
        setModalAction("delete");
        return selectedData
      case "Edit User":
        setModalAction("edit");
        return selectedData
      default:
        return "DEFAULT"
    }
  },[modalType, modalIsOpen])

  const closeModal = () => {
    setModalIsOpen(false);
  }

  const columns = useMemo(() => {
    const allowEdit   = authorization.is_admin || authorization?.allowed_actions?.includes("edit_user")
    const allowDelete = authorization.is_admin || authorization?.allowed_actions?.includes("delete_user")
    const returnArr = [
      {
        'Header'      : <b className="display-name-header">{t('containers.administrationUsers.colId')}</b>,
        'headerStyle' : styles.headers,
        'id'          : 'user_id',
        'accessor'    : (data) => data.user_id,
        'style'       : styles.prewrap,
        'width'       : 40,
        sortMethod  : (a, b) => a.role_id - b.role_id,
      },
      {
        'Header'      : <b className="display-name-header">{t('containers.administrationUsers.colEmail')}</b>,
        'headerStyle' : styles.headers,
        'id'          : 'email',
        'accessor'    : (data) => data.email,
        'style'       : styles.prewrap,
        'width'       : 200,
        sortMethod  : (a, b) => a.role_id - b.role_id,
      },
      {
        'Header'      : <b className="display-name-header">{t('containers.administrationUsers.colRoles')}</b>,
        'headerStyle' : styles.headers,
        'id'          : 'assigned_roles',
        'accessor'    : (data) => data.roles_display.filter(el => el).map(el => <div key={el}>- {el}</div>),
        'style'       : styles.prewrap,
        'width'       : 150,
        sortMethod  : (a, b) => a.role_id - b.role_id,
      },
      {
        'Header'      : <b className="opi-header">{t('containers.administrationUsers.colAdmin')}</b>,
        'headerStyle' : styles.headers,
        'id'          : 'is_admin',
        'accessor'    : (data) => data.is_admin ? "Yes" : "No",
        'style'       : styles.prewrap,
        'width'       : 80,
      },
      {
        'Header'      : <b className="opi-header">{t('containers.administrationUsers.colActions')}</b>,
        'headerStyle' : styles.headers,
        'id'          : 'actions_display',
        'accessor'    : (data) => data.actions_display.filter(el => el).map(el => <div key={el}>- {el}</div>),
        'style'       : styles.prewrap,
        'width'       : 300,
      },
      {
        'Header'      : <b className="opi-header">{t('containers.administrationUsers.colManage')}</b>,
        'headerStyle' : styles.headers,
        'id'          : 'edit_role_id',
        'accessor'    : (data) => (
            <>
              { allowEdit && canModifyUser(userState.user.authorization, data) && <MdModeEdit className="Edit-user" size={28} style={styles.edit} onClick={()=>{
                setModalType("Edit User")
                setModalIsOpen(true)
                setSelectedData(data);
                }}>{t('containers.administration.buttonEdit')}</MdModeEdit> }
              { allowDelete && canModifyUser(userState.user.authorization, data) && <MdDeleteForever className="Delete-user" size={28} style={styles.delete} onClick={()=>{
                setModalType("Delete User")
                setModalIsOpen(true)
                setSelectedData(data);
              }}>{t('containers.administration.buttonDelete')}</MdDeleteForever> }
            </>
        ),
        'style' : styles.prewrap,
        'width' : 150,
      }
    ]
    return returnArr
  },[users, userState])

  return (
    <div>
      <AdministrationModal 
        openState={modalIsOpen} 
        title={modalType} 
        type={type}
        action={modalAction} 
        selectedData={modalData} 
        close={closeModal}/>
      <AdministrationTypeTable props={{ data: users, columns, type: type }} />
    </div>
  );

}
